import { MonthUsageDataType } from "../../useBillingInfo";

const UsageRow = ({ label, price, isTotal }) => (
    <div className={`d-flex align-items-center justify-content-between ${isTotal ? 'mt-4' : 'mb-4'}`}>
        <span className={`text-gray-600 ${isTotal ? 'fs-4 fw-bolder text-dark' : 'fs-6 fw-bold'}`}>
            {label}
        </span>
        <span className={`fw-bolder ${isTotal ? 'fs-4 text-dark' : 'text-gray-800'}`}>
            ${price}
        </span>
    </div>
);

interface UsageBreakUpProps {
    monthToDateUsage: MonthUsageDataType
}

const LastMonthUsageBreakup = (props: UsageBreakUpProps) => {
    const { monthToDateUsage } = props
    const meetingCost = monthToDateUsage?.meetingCost || 0
    const recordingCost = monthToDateUsage?.recordingCost || 0
    const storageCost = monthToDateUsage?.storageCost || 0
    const totalCost = monthToDateUsage?.totalCost || 0

    return (
        <div className="">

            <div className="card mb-5 mb-xl-10">
                <div className="card-header">
                    <div className="card-title m-0">
                        <h3 className="fw-bolder m-0 text-dark">Month to Date Usage Breakup</h3>
                    </div>
                </div>
                <div className="card-body p-9">
                    <div className="row">
                        <div className="col-lg-12">
                            <UsageRow isTotal={false} label="Meeting Usage" price={meetingCost.toFixed(2)} />
                            <UsageRow isTotal={false} label="Recording Usage" price={recordingCost.toFixed(2)} />
                            <UsageRow isTotal={false} label="Storage Usage" price={storageCost.toFixed(2)} />

                            {/* Separator Line */}
                            <div className="separator separator-dashed my-4 border-bottom"></div>

                            <UsageRow label="Total Usage" price={totalCost} isTotal={true} />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default LastMonthUsageBreakup;